import React from "react";

const Dropdown = ({
  options = [],
  placeholder = "Select an option",
  className = "",
  onChange,
  value,
  defaultValue,
  allowClear = false,
}) => {
  return (
    <div
      className={`w-full flex items-center appearance-none relative ${className}`}
    >
      <select
        className={`!bg-transparent text-white p-4 px-6 w-full appearance-none placeholder:text-white focus:outline-none cursor-pointer`}
        onChange={onChange}
        value={value}
        defaultValue={defaultValue}
      >
        <option value="" disabled={!allowClear} hidden={!allowClear}>
          {placeholder}
        </option>
        {options.map((option, index) => (
          <option key={index} value={option.value} className="bg-[#141414]">
            {option.label}
          </option>
        ))}
      </select>
      <span className="absolute inset-y-0 right-4 flex items-center pointer-events-none">
        <img src="/assets/icons/icon-arrow-drop-down.svg" alt="dropdown" />
      </span>
    </div>
  );
};

export default Dropdown;
